import { render, staticRenderFns } from "./AllergiesEdit.vue?vue&type=template&id=1b2d0865"
import script from "./AllergiesEdit.vue?vue&type=script&lang=js"
export * from "./AllergiesEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports